<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Parking Lot</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">Save</el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <h3 class="black-text">
        Lot Number: <span style="font-weight: normal">{{ lotNumber }}</span>
      </h3>
      <h3 class="black-text">
        State: <span style="font-weight: normal">{{ state }}</span>
      </h3>

      <el-checkbox v-model="useAlternateRing" style="margin-left: 0;">
        Use alternate ringback
      </el-checkbox>
      <el-select
        v-if="useAlternateRing"
        v-model="altRingValue"
        placeholder="Select Alternate Ringtone"
        style="margin-left: 0; margin-top: 10px; display: block; width: 100%; max-width: 300px;"
      >
        <el-option label="Alternate Ringtone 1" value="ALTERNATERINGTONE1" />
        <el-option label="Alternate Ringtone 2" value="ALTERNATERINGTONE2" />
        <el-option label="Alternate Ringtone 3" value="ALTERNATERINGTONE3" />
        <el-option label="Alternate Ringtone 4" value="ALTERNATERINGTONE4" />
        <el-option label="Alternate Ringtone 5" value="ALTERNATERINGTONE5" />
        <el-option label="Alternate Ringtone 6" value="ALTERNATERINGTONE6" />
        <el-option label="Alternate Ringtone 7" value="ALTERNATERINGTONE7" />
        <el-option label="Alternate Ringtone 8" value="ALTERNATERINGTONE8" />
        <el-option label="Alternate Ringtone 9" value="ALTERNATERINGTONE9" />
        <el-option label="Alternate Ringtone 10" value="ALTERNATERINGTONE10" />
      </el-select>

      <destination-selector
        :clearable="true"
        :clearFields="clearForm"
        title="Timeout Destination"
        :selectedDestination="destination"
        @destinationCleared="destination = $event"
        @destinationSelected="destination = $event"
      />
    </el-form>
  </el-dialog>
</template>

<script>
import DestinationSelector from "@/components/DestinationSelector.vue";

export default {
  name: "EditParkinglotForm",

  components: {
    DestinationSelector,
  },

  props: {
    clearForm: {
      type: Boolean,
      required: true,
    },
    editVisible: { required: true },
    editProcessing: { required: true },
    selectedParkinglot: { required: true },
  },

  data() {
    return {
      destination: {
        id: null,
        type: "",
        options: [],
      },
      useAlternateRing: false,
      altRingValue: null
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    lotNumber() {
      return this.selectedParkinglot
        ? this.selectedParkinglot.space.split("-")[0]
        : "";
    },

    state() {
      if (!this.selectedParkinglot) return "";

      return this.selectedParkinglot.state === 0 ? "Empty" : "Full";
    },
  },

  watch: {
    clearForm(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedParkinglot(val) {
      if (val) {

        const { timeoutDestinations, useAlternateRing } = val;
        if (timeoutDestinations.length) {
          const { id, type, destination } = timeoutDestinations[0];

          this.destination = {
            id,
            type,
            options: [destination],
          }
        }

        this.useAlternateRing = !!useAlternateRing;
        this.altRingValue = val.altRingValue || null;
      }
    },
  },

  methods: {
    clearFields() {
      this.destination = {
        id: null,
        type: "",
        options: [],
      };
      this.useAlternateRing = false;
      this.altRingValue = null;
    },

    async editOperation() {
      if (this.useAlternateRing && !this.altRingValue) {
        this.$notify({
          title: "Missing alternate ringtone",
          message: "Please select an alternate ringtone or uncheck \"Use alternate ringback\".",
          type: "warning",
        });
        return;
      }

      const { id, type } = this.destination;

      const timeoutDestinations = [];
      if ((id && type) || id === 0) {
        timeoutDestinations.push({
          id,
          type,
        });
      }

      const editBody = {
        useAlternateRing: this.useAlternateRing ? 1 : 0,
        altRingValue: this.useAlternateRing ? this.altRingValue : null,
        timeoutDestinations
      };

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  max-width: 600px;
  margin: 0 auto;
}
</style>
